export default __webpack_public_path__ + "static/media/CIA-Fidelity-Computer-Crime-Declaration-ManagingAgent.c2a53d57.pdf";